import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OptInComponent } from './opt-in.component';
import { NotFoundModule } from '../shared/not-found/not-found.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NotFoundModule,
  ],
  declarations: [
    OptInComponent
  ],
  exports: [
    OptInComponent
  ]
})
export class OptInModule { }
